export const MONTHLY_TO_ANNUAL_CONTENT = {
    ctaText: 'UPGRADE TO POWER ANNUAL PLAN',
    ctaProcessing: 'Processing...',
    prorationMessage: 'Remaining days in your monthly plan will rollover to your annual membership.',
    paymentMethodTitle: 'Payment Method',
    changeCard: 'Change Card',
    useCardOnFile: 'Use card on file',
    changeCardInstruction: 'Please enter your new credit card information below.',
    cardholderNameLabel: 'Cardholder Name',
    nameValidationError: 'You must provide a name',
    cardBrandsText: 'We accept all major credit cards.',
    disclaimer: {
        prefix: 'By tapping the button, I agree to the ',
        termsLink: 'Terms of Service',
        termsHref: '/terms',
        suffix: ' and automatic charges until I cancel.',
    },
};

export const CARD_BRAND_ICON_MAP = {
    visa: '/img/v3/graphics/cards/visa.png',
    mastercard: '/img/v3/graphics/cards/mastercard.png',
    'american express': '/img/v3/graphics/cards/amex.png',
    amex: '/img/v3/graphics/cards/amex.png',
    discover: '/img/v3/graphics/cards/discover.png',
};

export const ACCEPTED_CARD_BRANDS = ['visa', 'mastercard', 'amex', 'discover'];
